"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredEligibility = exports.getFilteredPunchesEligibilityWithTimeRange = exports.getSelectedDatePunchTimeSegment = exports.getSelectedPunchCorrections = exports.PunchFeature = void 0;
var react_1 = __importStar(require("react"));
var luxon_1 = require("luxon");
var PunchSection_1 = require("./PunchSection");
var DateManagement_1 = require("../../utils/DateManagement");
var hooks_1 = require("../../hooks");
var atoz_shiftapp_utilities_1 = require("@amzn/atoz-shiftapp-utilities");
var atoz_dashboard_taa_components_1 = require("@amzn/atoz-dashboard-taa-components");
var atoz_shiftapp_metrics_1 = require("@amzn/atoz-shiftapp-metrics");
var PunchFeature = function (props) {
    var _a = (0, atoz_shiftapp_utilities_1.useAssociateContext)(), associateInfo = _a.associateInfo, features = _a.features;
    (0, react_1.useEffect)(function () {
        atoz_shiftapp_metrics_1.logger.info('PunchFeature', {
            employeeId: associateInfo.employeeId,
            siteId: associateInfo.siteId,
            features: features
        });
    }, []);
    if (features.useTaaDashboardComponents) {
        var featureGates = {
            isPunchCorrStatusV1Enabled: features.isPunchCorrStatusV1Enabled,
            useUnifiedPunchesAPIForWeb: features.useUnifiedPunchesAPIForWeb,
            useUnifiedPunchesAPIForNative: features.useUnifiedPunchesAPIForNative,
            isPunchEditForWebEnabled: (features.isPopstarTaaFeaturesOverrideEnabled
                ? features.isPunchEditForWebEnabled &&
                    features.isPunchEditFeatureEnabled
                : features.isPunchEditForWebEnabled) &&
                features.canSubmitMissedPunch,
            isMissedPunchClickableRowForWebEnabled: features.isMissedPunchClickableRowForWebEnabled,
            isPunchCorrStatusEnabled: features.punchCorrStatusEnabled,
            isTimecardModalEnabled: features.isTimecardModalEnabled,
            showRoundedPunch: features.showRoundedPunch,
            canSubmitMissedPunch: features.canSubmitMissedPunch,
            isSubmitMissedPunchV2Enabled: features.isSubmitMissedPunchV2Enabled,
            isTimeCardPunchWebEnabled: features.isTimeCardPunchWebEnabled,
            isTimeCardTaskListWebEnabled: features.isTimeCardTaskListWebEnabled,
            isDeleteMpcaMpcsForWebEnabled: features.isDeleteMpcaMpcsForWebEnabled,
            isATPlusTemporalRoutingEnabled: features.isATPlusTemporalRoutingEnabled
        };
        return (react_1.default.createElement(atoz_dashboard_taa_components_1.PunchFeature, { selectedDateTime: props.selectedDate, militaryTime: props.militaryTime, ctkPolicy: props.ctkPolicy, hasUnverifiedMissedPunchLimit: props.hasUnverifiedMissedPunchLimit, canDeleteDuplicatePunch: props.canDeleteDuplicatePunch, punchAutomationPolicy: props.punchAutomationPolicy, associateInfo: props.associateInfo, featureGates: featureGates, onRedirect: props.onRedirect, clientType: props.clientType, fesPolicyMissingFG: props.fesPolicyMissingFG, fesPolicyMissingFGLogs: props.fesPolicyMissingFGLogs }));
    }
    return react_1.default.createElement(PunchFeatureInternal, __assign({}, props));
};
exports.PunchFeature = PunchFeature;
var PunchFeatureInternal = function (_a) {
    var _b, _c, _d, _e;
    var canDeleteDuplicatePunch = _a.canDeleteDuplicatePunch, ctkPolicy = _a.ctkPolicy, hasUnverifiedMissedPunchLimit = _a.hasUnverifiedMissedPunchLimit, punchAutomationPolicy = _a.punchAutomationPolicy, militaryTime = _a.militaryTime, selectedDate = _a.selectedDate, associateInfo = _a.associateInfo, timeRange = _a.timeRange;
    var data = (0, hooks_1.usePunches)({
        employeeId: associateInfo.employeeId,
        timeRange: timeRange,
        isEligibilityEnabled: canDeleteDuplicatePunch
    }).data;
    var _f = (0, hooks_1.usePayPeriods)({
        employeeId: associateInfo.employeeId,
        shouldFetch: canDeleteDuplicatePunch || punchAutomationPolicy
    }).data, _g = _f === void 0 ? {} : _f, pay_period_breakdown_info = _g.pay_period_breakdown_info;
    var _h = (0, hooks_1.usePunchCorrections)({
        employeeId: associateInfo.employeeId,
        timeRange: {
            start: (_b = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current.start_time) !== null && _b !== void 0 ? _b : '',
            end: (_c = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current.end_time) !== null && _c !== void 0 ? _c : ''
        },
        shouldFetch: punchAutomationPolicy && !!(pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current)
    }), _j = _h.data, _k = _j === void 0 ? {} : _j, punchCorrections = _k.punchCorrections, refetchPunchCorrections = _h.refetch;
    var filteredPunches = (0, exports.getFilteredPunchesEligibilityWithTimeRange)(canDeleteDuplicatePunch, selectedDate, data === null || data === void 0 ? void 0 : data.punchesTimeSegments, {
        start: (_d = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current.start_time) !== null && _d !== void 0 ? _d : '',
        end: (_e = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current.end_time) !== null && _e !== void 0 ? _e : ''
    });
    var filteredPunchCorrections = (0, exports.getSelectedPunchCorrections)(punchCorrections, selectedDate);
    return (react_1.default.createElement(PunchSection_1.PunchSection, { punchesTimeSegments: filteredPunches, punchCorrections: filteredPunchCorrections, ctkPolicy: ctkPolicy, hasUnverifiedMissedPunchLimit: hasUnverifiedMissedPunchLimit, punchAutomationPolicy: punchAutomationPolicy, militaryTime: militaryTime, selectedDate: selectedDate, associateInfo: associateInfo, refetch: function () {
            if (refetchPunchCorrections) {
                refetchPunchCorrections();
            }
        } }));
};
var getSelectedPunchCorrections = function (punchCorrections, selectedDate) {
    if (punchCorrections === void 0) { punchCorrections = []; }
    var filteredPunchCorrections = punchCorrections.filter(function (punchCorrection) {
        return (0, DateManagement_1.areDatesEqual)(selectedDate, luxon_1.DateTime.fromISO(punchCorrection.correctionDateTime));
    });
    return filteredPunchCorrections;
};
exports.getSelectedPunchCorrections = getSelectedPunchCorrections;
var getSelectedDatePunchTimeSegment = function (punchTimeSegments, selectedDate) {
    if (punchTimeSegments === void 0) { punchTimeSegments = []; }
    var filteredPunchTimeSegments = punchTimeSegments.filter(function (punch) {
        var punchTime = punch.startDateTime || punch.endDateTime;
        var punchDateTime = punchTime ? luxon_1.DateTime.fromISO(punchTime) : null;
        return punchDateTime && (0, DateManagement_1.areDatesEqual)(selectedDate, punchDateTime);
    });
    return filteredPunchTimeSegments;
};
exports.getSelectedDatePunchTimeSegment = getSelectedDatePunchTimeSegment;
var getFilteredPunchesEligibilityWithTimeRange = function (canDeleteDuplicatePunch, selectedDate, punchTimeSegments, timeRange) {
    if (punchTimeSegments === void 0) { punchTimeSegments = []; }
    var selectedPunches = (0, exports.getSelectedDatePunchTimeSegment)(punchTimeSegments, selectedDate);
    var interval = luxon_1.Interval.fromDateTimes(luxon_1.DateTime.fromISO(timeRange.start), luxon_1.DateTime.fromISO(timeRange.end));
    if (canDeleteDuplicatePunch && !interval.contains(selectedDate)) {
        return selectedPunches.map(function (punch) { return (0, exports.getFilteredEligibility)(punch); });
    }
    return selectedPunches;
};
exports.getFilteredPunchesEligibilityWithTimeRange = getFilteredPunchesEligibilityWithTimeRange;
var getFilteredEligibility = function (punch) {
    return {
        startDateTime: punch.startDateTime,
        endDateTime: punch.endDateTime,
        eligibility: {
            startTimeDeletable: false,
            endTimeDeletable: false
        }
    };
};
exports.getFilteredEligibility = getFilteredEligibility;
